"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _Functions = require("../core/Functions");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIDropdown = _interopRequireDefault(require("../dropdown/UIDropdown"));

var _HiddenMeasure = _interopRequireDefault(require("../layout/utils/HiddenMeasure"));

var _UIList = _interopRequireDefault(require("../list/UIList"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _createChainablePropType = _interopRequireDefault(require("../utils/propTypes/createChainablePropType"));

var _Styles = require("../utils/Styles");

var _TabConstants = require("./TabConstants");

var _tabUtils = require("./utils/tabUtils");

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n            background-color: ", ";\n            border-left: 1px solid ", ";\n            border-radius: 0;\n          "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* Extra specificity to override .private-button-transparent.private-button--default rules */\n  &&& {\n    ", ";\n    flex-shrink: 0;\n\n    ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          margin-bottom: 40px;\n\n          & > ", " {\n            padding-left: ", ";\n          }\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 100%;\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          position: relative;\n          &::before {\n            border-top: 1px solid\n              ", ";\n            bottom: -1px;\n            content: '';\n            left: 0;\n            position: absolute;\n            width: 100%;\n          }\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  padding: 16px;\n  border-top: 1px solid\n    ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        border-top: 1px solid ", ";\n        ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        border: 1px solid ", ";\n        border-top-left-radius: ", ";\n        border-top-right-radius: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        padding-left: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: ", ";\n  width: ", ";\n  margin-bottom: -1px;\n\n  border-bottom: 1px solid\n    ", ";\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var HIDDEN_CLASSNAME_REGEX = /sr-only(-focusable)?/g;

var isTabComponent = function isTabComponent(child) {
  var propTypes = child && child.type && child.type.propTypes;
  return propTypes && propTypes.tabId && propTypes.title;
};

var isWhitespace = function isWhitespace(str) {
  return typeof str === 'string' && !str.match(/\S/);
};

var getActiveTabPanel = function getActiveTabPanel(selected, childArray) {
  for (var i = 0; i < childArray.length; i++) {
    var child = childArray[i];

    var _ref = child && child.props ? child.props : {},
        tabContent = _ref.children,
        tabId = _ref.tabId;

    if (tabId === selected) {
      return tabContent;
    }
  }

  return null;
};
/**
 * @param {HTMLElement} el
 * @returns {number} The precise width of the element's bounding box (`clientWidth` is rounded)
 */


var getElementWidth = function getElementWidth(el) {
  return el.getBoundingClientRect().width;
};

var getAvailableWidth = function getAvailableWidth(parentEl, tabsEl) {
  var computedStyles = getComputedStyle(parentEl, null); // Patch for Firefox < 62: https://bugzilla.mozilla.org/show_bug.cgi?id=1467722

  if (!computedStyles) return Infinity;
  var innerWidth = getElementWidth(parentEl) - parseFloat(computedStyles.paddingLeft, 10) - parseFloat(computedStyles.paddingRight, 10);
  var availableWidth = innerWidth; // Special case: If we're in a horizontal flex container, respect our siblings' space.

  if (computedStyles.display === 'flex' && computedStyles.flexDirection === 'row' && computedStyles.flexWrap === 'nowrap') {
    var childNodes = parentEl.childNodes;

    for (var i = 0; i < childNodes.length; i++) {
      if (childNodes[i] !== tabsEl) availableWidth -= getElementWidth(childNodes[i]);
    }
  }

  return availableWidth;
}; // `PropTypes.children`, but checks all children are `UITab` nodes


var childrenPropTypeValidator = (0, _createChainablePropType.default)(function (props, propName, componentName) {
  // Only accept UITab instances as children
  var valid = true;

  _react.Children.forEach(props[propName], function (child) {
    if (child != null && !isTabComponent(child) && !isWhitespace(child)) {
      valid = false;
    }
  });

  if (!valid) {
    return new Error(componentName + ": All children must be instances of UITab.");
  }

  return null;
}, 'node' // TODO: render "`UITab`s" instead, linked to the UITab docs
);
var listRightBorderMixin = (0, _styledComponents.css)(_templateObject(), function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return !fullWidth && "1px solid " + _TabConstants.BORDER_COLOR;
});

var StyledList = _styledComponents.default.div.withConfig({
  displayName: "UITabs__StyledList",
  componentId: "qdpko9-0"
})(_templateObject2(), function (_ref3) {
  var use = _ref3.use;
  return (0, _tabUtils.isContained)(use) ? 'inline-flex' : 'flex';
}, function (_ref4) {
  var fullWidth = _ref4.fullWidth;
  return fullWidth && '100%';
}, function (_ref5) {
  var bordered = _ref5.bordered;
  return bordered ? _TabConstants.BORDER_COLOR : 'transparent';
}, function (_ref6) {
  var use = _ref6.use;
  if (use === 'header') return (0, _styledComponents.css)(_templateObject3(), _sizes.LAYOUT_PADDING_X);
  if (use === 'enclosed') return (0, _styledComponents.css)(_templateObject4(), _TabConstants.BORDER_COLOR, _sizes.BUTTON_RADIUS, _sizes.BUTTON_RADIUS);
  if (use === 'flush' || use === 'enclosed-shaded') return (0, _styledComponents.css)(_templateObject5(), _TabConstants.BORDER_COLOR, listRightBorderMixin);
  if (use === 'toolbar') return listRightBorderMixin;
  return null;
});

StyledList.displayName = 'UITabs__StyledUITabsList';
var TabsPanel = (0, _styledComponents.default)(function (props) {
  var __use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["use"]);
  return _react.default.createElement(_UISection.default, rest);
}).withConfig({
  displayName: "UITabs__TabsPanel",
  componentId: "qdpko9-1"
})(_templateObject6(), function (_ref7) {
  var use = _ref7.use;
  return use === 'enclosed-shaded' && _TabConstants.ENCLOSED_SHADED_SELECTED_BACKGROUND_COLOR;
}, function (_ref8) {
  var bordered = _ref8.bordered;
  return bordered ? _TabConstants.BORDER_COLOR : 'transparent';
});

var StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "UITabs__StyledWrapper",
  componentId: "qdpko9-2"
})(_templateObject7(), function (_ref9) {
  var use = _ref9.use;
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(_templateObject8(), function (_ref10) {
    var bordered = _ref10.bordered;
    return bordered ? _TabConstants.BORDER_COLOR : 'transparent';
  }) : null;
});

StyledWrapper.displayName = 'UITabs__StyledUITabsWrapper';

var StyledUITabs = _styledComponents.default.div.withConfig({
  displayName: "UITabs__StyledUITabs",
  componentId: "qdpko9-3"
})(_templateObject9(), function (_ref11) {
  var use = _ref11.use;
  return use === 'header' ? (0, _styledComponents.css)(_templateObject10(), TabsPanel, _sizes.LAYOUT_PADDING_X) : null;
});

var ExcessTabsDropdownButton = (0, _styledComponents.default)(function (props) {
  var __parentUse = props.parentUse,
      rest = (0, _objectWithoutProperties2.default)(props, ["parentUse"]);
  return _react.default.createElement(_UIButton.default, rest);
}).withConfig({
  displayName: "UITabs__ExcessTabsDropdownButton",
  componentId: "qdpko9-4"
})(_templateObject11(), (0, _Styles.setInputMetrics)(_sizes.TAB_PADDING_Y, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_Y, false), function (_ref12) {
  var use = _ref12.parentUse;
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(_templateObject12(), (0, _tabUtils.getSelectedTabBackgroundColor)(use), _TabConstants.BORDER_COLOR) : null;
});

var renderExcessTabsDropdown = function renderExcessTabsDropdown(moreTabsRenderer, childArray, excessTabCount, use, handleTabClick) {
  if (moreTabsRenderer == null) return null;
  var excessTabs = childArray.slice(childArray.length - excessTabCount);
  var excessTabListItems = excessTabs.map(function (child) {
    var _ref13 = child && child.props ? child.props : {},
        onClick = _ref13.onClick;

    return _react.default.cloneElement(child, {
      onClick: (0, _Functions.memoizedSequence)(handleTabClick, onClick),
      active: false,
      children: null,
      role: 'button',
      tooltipPlacement: undefined
    });
  });
  return _react.default.cloneElement(moreTabsRenderer({
    tabs: excessTabListItems,
    use: use
  }), {
    'data-more-tabs': true
  });
};

var UITabs = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UITabs, _PureComponent);

  function UITabs() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UITabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UITabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      excessTabCount: 0
    };

    _this.checkFit = function () {
      var moreTabsRenderer = _this.props.moreTabsRenderer;
      var excessTabCount = _this.state.excessTabCount;

      if (moreTabsRenderer == null) {
        if (excessTabCount !== 0) _this.setState({
          excessTabCount: 0
        });
        return;
      }

      var measureEl = _this._measureEl;
      var outerEl = _this._outerEl;
      var parentEl = outerEl.parentElement; // Tally the total tab width. If it's less than the available width, things are simple!

      var containerWidth = Math.ceil(getAvailableWidth(parentEl, outerEl));
      var totalTabsWidth = 0;
      var measureTabsArr = (0, _toConsumableArray2.default)(measureEl.querySelectorAll('[data-tab-id]'));
      measureTabsArr.forEach(function (tabEl) {
        totalTabsWidth += getElementWidth(tabEl);
      });

      if (totalTabsWidth <= containerWidth) {
        if (excessTabCount !== 0) _this.setState({
          excessTabCount: 0
        });
        return;
      } // At this point, we know we can't fit all the tabs. How many do we relegate to the dropdown?
      // We start with the "More" dropdown and the active tab...


      var visibleContentWidth = getElementWidth(measureEl.querySelector('[data-more-tabs]'));
      var activeTab = measureTabsArr.find(function (el) {
        return el.getAttribute('data-tab-selected') === 'true';
      });
      if (activeTab) visibleContentWidth += getElementWidth(activeTab); // ...Then we add as many inactive tabs (from left to right) as we can fit.

      var inactiveTabEls = measureTabsArr.filter(function (el) {
        return el.getAttribute('data-tab-selected') !== 'true';
      });
      var newExcessTabCount = inactiveTabEls.length;

      for (var i = 0; i < inactiveTabEls.length; i++) {
        var tabWidth = getElementWidth(inactiveTabEls[i]);
        if (visibleContentWidth + tabWidth > containerWidth) break;
        visibleContentWidth += tabWidth;
        newExcessTabCount -= 1;
      }

      if (newExcessTabCount !== excessTabCount) {
        _this.setState({
          excessTabCount: newExcessTabCount
        });
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UITabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.ResizeObserver) {
        this._resizeObserver = new ResizeObserver(this.checkFit);

        this._resizeObserver.observe(this._outerEl.parentElement);

        this._resizeObserver.observe(this._measureEl);
      } else {
        this.checkFit();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.selected !== this.props.selected || !this._resizeObserver) {
        // ⚠️ This condition prevents infinite loops! ⚠️
        if (prevState.excessTabCount === this.state.excessTabCount) {
          this.checkFit();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          bordered = _this$props.bordered,
          children = _this$props.children,
          className = _this$props.className,
          fill = _this$props.fill,
          listClassName = _this$props.listClassName,
          moreTabsRenderer = _this$props.moreTabsRenderer,
          onSelectedChange = _this$props.onSelectedChange,
          panelClassName = _this$props.panelClassName,
          selected = _this$props.selected,
          List = _this$props.List,
          use = _this$props.use,
          Wrapper = _this$props.Wrapper,
          wrapperClassName = _this$props.wrapperClassName,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["bordered", "children", "className", "fill", "listClassName", "moreTabsRenderer", "onSelectedChange", "panelClassName", "selected", "List", "use", "Wrapper", "wrapperClassName"]);
      var excessTabCount = this.state.excessTabCount;

      var childArray = _react.Children.toArray(children).filter(function (child) {
        return child && child.type;
      });

      var classes = (0, _classnames.default)(className, 'private-tabs', {
        'private-tabs--header': use === 'header'
      }); // If the selected tab would be in the excess tab dropdown, move it to
      // first position instead.

      if (excessTabCount > 0) {
        for (var i = childArray.length - excessTabCount; i < childArray.length; i++) {
          if (childArray[i] && childArray[i].props.tabId === selected) {
            var firstChild = childArray[0];
            childArray[0] = childArray[i];
            childArray[i] = firstChild;
            break;
          }
        }
      }

      var activeTabPanel = getActiveTabPanel(selected, childArray);
      var componentRole = activeTabPanel ? 'tablist' : 'navigation';
      var excessTabsDropdown = renderExcessTabsDropdown(moreTabsRenderer, childArray, excessTabCount, use, onSelectedChange);
      var tabs = childArray.map(function (child, i) {
        var _ref14 = child.props ? child.props : {},
            active = _ref14.active,
            childClassName = _ref14.className,
            tabId = _ref14.tabId,
            onClick = _ref14.onClick;

        var hidden = i >= childArray.length - excessTabCount;
        var tabRole = activeTabPanel ? 'tab' : 'button';
        return _react.default.cloneElement(child, {
          onClick: (0, _Functions.memoizedSequence)(onSelectedChange, onClick),
          active: active != null ? active : tabId === selected,
          'aria-current': !activeTabPanel && tabId === selected ? 'page' : null,
          'aria-selected': activeTabPanel && tabId === selected ? true : null,
          children: null,
          className: (0, _classnames.default)(childClassName, {
            'sr-only': hidden,
            'sr-only-focusable': hidden
          }),
          role: tabRole,
          use: use,
          fill: fill
        });
      });
      var measureChildren = tabs.map(function (tab) {
        return _react.default.cloneElement(tab, {
          className: tab.props.className.replace(HIDDEN_CLASSNAME_REGEX, ''),
          tooltip: undefined
        });
      });
      return _react.default.createElement(StyledUITabs, (0, _extends2.default)({
        className: classes,
        ref: function ref(_ref16) {
          _this2._outerEl = (0, _reactDom.findDOMNode)(_ref16);
        },
        use: use
      }, rest), _react.default.createElement(Wrapper, {
        bordered: bordered,
        className: (0, _classnames.default)('private-tabs__list__wrapper', wrapperClassName),
        use: use
      }, _react.default.createElement(List, {
        bordered: bordered,
        className: (0, _classnames.default)('private-tabs__list', listClassName),
        "data-content": true,
        role: componentRole,
        use: use,
        fullWidth: fill
      }, tabs, excessTabCount > 0 && excessTabsDropdown), _react.default.createElement(_HiddenMeasure.default, {
        ref: function ref(_ref15) {
          _this2._measureEl = (0, _reactDom.findDOMNode)(_ref15);
        },
        style: {
          height: 0
        }
      }, _react.default.createElement(List, {
        bordered: bordered,
        use: use
      }, measureChildren, excessTabsDropdown))), activeTabPanel ? _react.default.createElement(TabsPanel, {
        bordered: bordered,
        className: (0, _classnames.default)(panelClassName, 'private-tabs__panel'),
        role: "tabpanel",
        use: use
      }, activeTabPanel) : null);
    }
  }]);
  return UITabs;
}(_react.PureComponent);

UITabs.displayName = 'UITabs';
UITabs.propTypes = {
  bordered: _propTypes.default.bool.isRequired,
  children: childrenPropTypeValidator,
  fill: _propTypes.default.bool,
  List: _propTypes.default.elementType,
  listClassName: _propTypes.default.string,
  moreTabsRenderer: _propTypes.default.func,
  onSelectedChange: _propTypes.default.func.isRequired,
  panelClassName: _propTypes.default.string,
  selected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  use: _propTypes.default.oneOf(_tabUtils.USES),
  Wrapper: _propTypes.default.elementType,
  wrapperClassName: _propTypes.default.string
};
UITabs.defaultProps = {
  bordered: true,
  fill: false,
  moreTabsRenderer: function moreTabsRenderer(_ref17) {
    var tabs = _ref17.tabs,
        use = _ref17.use;
    return _react.default.createElement(_UIDropdown.default, {
      Button: ExcessTabsDropdownButton,
      "aria-hidden": true,
      buttonClassName: "private-tabs__excess-tabs-dropdown",
      buttonText: _I18n.default.text('salesUI.UITabs.moreDropdownLabel'),
      buttonUse: "transparent",
      "data-dropdown-tabs": tabs.length,
      placement: "bottom left",
      responsive: false,
      tabIndex: -1,
      parentUse: use
    }, _react.default.createElement(_UIList.default, null, tabs));
  },
  List: StyledList,
  Wrapper: StyledWrapper
};

var _default = (0, _Controllable.default)(UITabs, ['selected']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/nav/UITabs.js
// module id = 789
// module chunks = 209 210 211 212